<app-checkbox-input labelKey="button.edit" [(ngModel)]="edit" color="primary"></app-checkbox-input>
<form [formGroup]="form">
  <app-text-input labelKey="form.title" formControlName="title" [disabled]="!edit"></app-text-input>
  <mat-label for="description">{{ 'form.content' | loc }}</mat-label>
  <app-rich-text-editor
    id="description"
    [disabled]="!edit"
    [maxLength]="4000"
    [defaultText]="setup.description"
  ></app-rich-text-editor>

  <div class="row-2">
    <app-date-input
      [labelKey]="'res.reminderDuration' | toLL: 'capitalize'"
      formControlName="dateFrom"
      [min]="NOW"
    ></app-date-input>
    <app-date-input labelKey="label.to" formControlName="dateTo" [min]="NOW"></app-date-input>
  </div>
</form>

<ng-content></ng-content>

<app-notification-type-select
  [(value)]="notificationTypes"
  [enabled]="{ mobile: !!users.size, email: emailFlag && !!emails.size }"
></app-notification-type-select>

<h2 class="mat-title">{{ 'res.photosAndAttachments' | loc }}</h2>
<div class="attachments">
  <app-add-picture-field
    [images]="setup.photos"
    uploadFilePath="static/news/image"
    (onSumSizeChange)="fileSize.photos = $event"
  ></app-add-picture-field>
  <app-add-attachment-field
    [attachments]="setup.attachments"
    uploadFilePath="static/news/pdf"
    (onSumSizeChange)="fileSize.attachments = $event"
  ></app-add-attachment-field>
  <mat-error *ngIf="attachmentsOverLimit">
    {{ 'attachment.sizeError' | locRep: { $max: (FILE_SIZE_LIMIT | fileSize), $current: (attachmentSizeSum | fileSize) } }}
  </mat-error>
</div>
